import fetch from "@/utils/fetch";

// zym.省局：出版单位审核列表
export function getProvinceList(params) {
  return fetch({
    //  url:'Ydnj/Ydnj/getExamineProvinceList',
    url: "eavar/bureau/examine/list",
    method: "post",
    data: params,
  });
}

// zym.省局：审核
export function goProvinceExam(params) {
  return fetch({
    //  url:'Ydnj/Ydnj/batchExamineProvince',
    url: "eavar/bureau/examine/batchExamineProvince",
    method: "post",
    data: params,
  });
}

// zym.省局上报总局
export function stepToAdmin(params) {
  return fetch({
    //  url:'Ydnj/Ydnj/submitProvince',
    url: "eavar/bureau/submitProvince",
    method: "post",
    data: params,
  });
}

/* 省局是否上报 */

export function isSubmited(params) {
  return fetch({
    url: "Ydnj/Ydnj/isSubmit",
    method: "post",
    data: params,
  });
}

// zym.省局登记列表
export function registList(params) {
  return fetch({
    //  url:'Ydnj/Ydnj/getRecordExamineProvinceList',
    url: "eavar/bureau/examine/getRecordExamineProvinceList",
    method: "post",
    data: params,
  });
}

// zym.省局登记
export function goRegist(params) {
  return fetch({
    //  url:'Ydnj/Ydnj/register',
    url: "eavar/bureau/goRegist",
    method: "post",
    data: params,
  });
}

// zym.连续型出版物审核列表
export function successiveWaitList(params) {
  return fetch({
    //  url:'Ydnj/Ydnj/getLxdzMaterialExamineProvinceList',
    url: "lxdzpress/lxdz/getLxProvinceMaterialList",
    method: "post",
    data: params,
  });
}

// zym.连续型出版物登记列表
export function successiveRegistList(params) {
  return fetch({
    //  url:'Ydnj/Ydnj/getLxdzMaterialRecordList',
    url: "lxdzpress/lxdz/getLxdzMaterialRecordList",
    method: "post",
    data: params,
  });
}

// zym.流转记录（原审核历史） - 新
export function successiveHistoryNew(params) {
  return fetch({
    //  url:'Ydnj/Ydnj/getFlowTasks',
    url: "eavar/examine/getExamineFlowNew",
    method: "post",
    data: params,
  });
}

// zym.流转记录（原审核历史） - 废弃（省局审核页面）
export function successiveHistory(params) {
  return successiveHistoryNew(params);
  // return fetch({
  //     //  url:'Ydnj/Ydnj/getFlowTasks',
  //      url:'eavar/examine/flow',
  //      method:"post",
  //      data:params
  // })
}

// zym.判断是否已审核完毕
export function successiveReported(params) {
  return fetch({
    //  url:'Ydnj/Ydnj/getStatus',
    url: "eavar/bureau/getStatus",
    method: "post",
    data: params,
  });
}

// zym.获取核验上传报告
export function ssReportLoad(params) {
  return fetch({
    //  url:'Ydnj/Ydnj/getReport',
    url: "eavar/bureau/report",
    method: "post",
    data: params,
  });
}

// zym.获取整改报告
export function getPostponeDesc(params) {
  return fetch({
    //  url:'Ydnj/Ydnj/getPostponeDesc',
    url: "eavar/bureau/getPostponeDesc",
    method: "post",
    data: params,
  });
}

// zym.省局：上传/更新分析报告
export function ssReportUpload(params) {
  return fetch({
    //  url:'Ydnj/Ydnj/upReport',
    url: "eavar/bureau/upReport",
    method: "post",
    data: params,
  });
}

// zym.省局：上传/更新整改报告
export function upPostponeDesc(params) {
  return fetch({
    //  url:'Ydnj/Ydnj/upReport',
    url: "eavar/bureau/upPostponeDesc",
    method: "post",
    data: params,
  });
}

/* 音像电子出版单位查询 */

export function pressSeek(params) {
  return fetch({
    //  url:'Ydnj/Ydnj/publisherMaterial',
    url: "eavar/publisher/list",
    method: "post",
    data: params,
  });
}

/* 连续查询 */

export function successiveSeek(params) {
  return fetch({
    //url:'Ydnj/Ydnj/lxPublisherMaterial',
    url: "eavar/publisher/lxPublisherMaterial",
    method: "post",
    data: params,
  });
}

// zym.获取出版单位各项统计信息
export function publishStatic(params) {
  return fetch({
    // url:'Ydnj/Ydnj/getPublisherStatistics',
    url: "eavar/examine/statistics",
    method: "post",
    data: params,
  });
}

// zym.审阅时间 - 音像、电子
export function writeReadTime(params) {
  return fetch({
    // url:'Ydnj/Ydnj/getPublisherStatistics',
    url: "eavar/bureau/writeReadTime",
    method: "post",
    data: params,
  });
}

// zym.审阅时间 - 连续电子
export function writeReadTimeLxdz(params) {
  return fetch({
    // url:'Ydnj/Ydnj/getPublisherStatistics',
    url: "eavar/bureau/writeReadTimeLxdz",
    method: "post",
    data: params,
  });
}

/* 省局首页增加各项统计下的出版单位数量 */

export function provinceStatistics(params) {
  return fetch({
    // url:'Ydnj/Ydnj/getProvinceStatisticsList',
    url: "eavar/bureau/examine/statistics",
    method: "post",
    data: params,
  });
}

// zym.省局：批量生成审核的条件数据
export function batchAuditGen(params) {
  return fetch({
    url: "eavar/bureau/examine/batchAuditGen",
    method: "post",
    data: params,
  });
}



// WEBPACK FOOTER //
// ./src/api/provinceRole/provinceRole.js